























































import { Component, Vue } from "vue-property-decorator";
import { namespace, Getter, Mutation, Action } from "vuex-class";
import { Guard } from "@/store/dispatch/types";
import { DispatchGuardType } from "@/store/mobile/types";

const Mobile = namespace("mobile");

@Component({})
export default class CallSignList extends Vue {
	// Guards
	@Mobile.Getter("getProximityCallSigns") proximityCallSigns!: Guard[];
	@Mobile.Getter("getCallSigns") callSigns!: Guard[];

	// Call signs
	@Mobile.Action setGuardForUser: any;
	@Mobile.Action loadCallSigns: () => Promise<void>;
	@Mobile.Getter("getCallSign") callSign: "";

	// User
	@Getter("getUserName") userFullName: string;

	public filterSearchText: string = "";
	private previousCardHeight: number = 0;

	private buttonVariant(callsignType: DispatchGuardType) {
		if (callsignType === DispatchGuardType.Assessor) {
			return "success";
		}

		return "primary";
	}

	public initializeGuardDetails(guardId: number) {
		// Find the guard by their call sign
		var callSign: Guard = this.callSigns.find(callSign => callSign.guardID === guardId);

		if (typeof callSign !== "undefined") {
			this.setGuardForUser(callSign.guardID);
		}
	}

	public get filteredCallsigns(): Guard[]  {
		if (this.callSigns.length > 0) {
			// Search the available call signs
			var filteredByCallsign = this.callSigns.filter(f =>
				f.callsign.toLowerCase().includes(this.filterSearchText.toLowerCase())
			);

			// Search the available callsigns, based on the patrol zone they belong to
			var filteredByPatrolZone = this.callSigns.filter(
				guard => {
					if (guard.patrolZones !== null)
					{
						// Get the values of the patrol zones for each guard
						Object.values(guard.patrolZones).filter(
							// On each patrol zone, filter by the search text
							patrolZone => patrolZone.toLowerCase().includes(this.filterSearchText.toLowerCase())
						).length > 0 // If the filter yielded results, return the object
					}
				}
			);

			// Put both the search result values into one array
			return filteredByCallsign.concat(filteredByPatrolZone);
		} else {
			return [];
		}
	}

	private updateFilterSearchText(event) {
		this.filterSearchText = this.filterSearchText;
	}

	private async reloadCallsignList(){
		await this.loadCallSigns();
	}
}
